var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.78922 0.294524L6 4.50513L10.189 0.316341C10.2815 0.217858 10.393 0.139075 10.5167 0.0847163C10.6404 0.0303576 10.7738 0.00154281 10.9089 0C11.1983 0 11.4757 0.114926 11.6803 0.319497C11.8849 0.524067 11.9998 0.801524 11.9998 1.09083C12.0024 1.22457 11.9776 1.35742 11.9269 1.48122C11.8763 1.60502 11.8008 1.71717 11.7053 1.81078L7.46177 5.99957L11.7053 10.2429C11.8851 10.4188 11.9905 10.657 11.9998 10.9083C11.9998 11.1976 11.8849 11.4751 11.6803 11.6796C11.4757 11.8842 11.1983 11.9991 10.9089 11.9991C10.7699 12.0049 10.6312 11.9817 10.5016 11.931C10.3721 11.8803 10.2544 11.8032 10.1562 11.7046L6 7.49401L1.80012 11.6937C1.70795 11.7889 1.59784 11.8649 1.47614 11.9173C1.35444 11.9698 1.22356 11.9976 1.09105 11.9991C0.801736 11.9991 0.524267 11.8842 0.319688 11.6796C0.115109 11.4751 0.000177493 11.1976 0.000177493 10.9083C-0.00236588 10.7746 0.0224482 10.6417 0.0730971 10.5179C0.123746 10.3941 0.199161 10.282 0.294714 10.1884L4.53822 5.99957L0.294714 1.75624C0.114921 1.58035 0.00949316 1.34217 0.000177493 1.09083C0.000177493 0.801524 0.115109 0.524067 0.319688 0.319497C0.524267 0.114926 0.801736 0 1.09105 0C1.35286 0.00327249 1.60377 0.109083 1.78922 0.294524Z",
    fill: "#C1C1C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCross);
export default __webpack_public_path__ + "static/media/closeCross.a2aef3858a14133a7eceb9472bef850a.svg";
export { ForwardRef as ReactComponent };